import { z } from "zod";

export const panelUserSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  name: z.string(),
  role: z.string(),
  capabilities: z.array(z.string()),
  mfa_recent: z.boolean(),
  totp_configured: z.boolean(),
});

export const authStateSchema = z.discriminatedUnion("stage", [
  z.object({ stage: z.literal("anonymous") }),
  z.object({ stage: z.literal("password_change"), email: z.string().email() }),
  z.object({ stage: z.literal("mfa"), email: z.string().email() }),
  z.object({
    stage: z.literal("enroll"),
    email: z.string().email(),
    secret: z.string().optional(),
    provisioning_uri: z.string().optional(),
  }),
  z.object({
    stage: z.literal("authenticated"),
    user: panelUserSchema,
    recovery_codes: z.array(z.string()).optional(),
  }),
]);

export const invitationSchema = z.object({
  email: z.string().email(),
  expires_at: z.string(),
});

export const acceptedActionSchema = z.object({ accepted: z.literal(true) });
export const validResetSchema = z.object({ valid: z.literal(true) });
export const completedResetSchema = z.object({ reset: z.literal(true) });

export type PanelUserDto = z.infer<typeof panelUserSchema>;
export type AuthStateDto = z.infer<typeof authStateSchema>;
export type InvitationDto = z.infer<typeof invitationSchema>;
